import { ImageSearchParameters, SearchOptions } from './background-theme.model';

export const defaultImageSearchParameters: ImageSearchParameters = {
    search: {
        types: ['wmammodularcontent_generic_image'],
        wmamodularcontent0frontend_image0component: '@ap/background-image'
    } as SearchOptions,
    options: {
        fullExport: false
    }
};
